import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastService } from '@shared/services/toast.service';

/**
 * Intercepta errores 403 con código `APPOINTMENT_NOT_STARTED` (gate de publicación
 * del backend cuando la modalidad es ACOMPANADO y aún no es el horario de la cita)
 * y muestra un toast amable sin bloquear la propagación del error.
 */
@Injectable()
export class AppointmentGateInterceptor implements HttpInterceptor {
  private readonly toast = inject(ToastService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && err.status === 403) {
          const body = err.error as { code?: string; message?: string } | null;
          if (body?.code === 'APPOINTMENT_NOT_STARTED') {
            this.toast.show({
              type: 'error',
              title: 'Aún no puedes publicar',
              body: 'Debes esperar a que inicie tu sesión acompañada para publicar.',
            });
          }
        }
        return throwError(() => err);
      })
    );
  }
}
